<template>
  <div class="contact">
    <Headers></Headers>
    <div class="contact-center">
      <img :src="bgUrl" />
      <div class="center-body">
        <h3>联系我们</h3>
        <div class="list-show"></div>
        <div class="body-list">
          <ul>
            <li v-for="(item, index) in navData" :key="index">
              <div>{{ item.textName }}</div>
              <div>{{ item.list }}</div>
            </li>
          </ul>
        </div>
        <div class="body-QR">
          <div class="QR-wechat">
            <div class="wechat-img"><img src="../assets/img/qrCode/guan.png" /></div>
            <p class="wechat-title">音 乐 窝</p>
            <p class="wechat-name">微信公众号</p>
          </div>
          <div class="QR-wechat">
            <div class="wechat-img">
              <img src="../assets/img/qrCode/wei.png" />
            </div>
            <p class="wechat-title">音 乐 窝</p>
            <p class="wechat-typeName">微 博 号</p>
          </div>
          <div class="QR-wechat">
            <div class="dy-img-wrap"><img style="height: auto;" src="../assets/img/qrCode/douyin.png" /></div>
            <p class="wechat-title">音 乐 窝</p>
            <p class="wechat-typeName">抖 音 号</p>
          </div>
          <div class="QR-wechat">
            <div class="wechat-img"><img src="../assets/img/qrCode/xiao.png" /></div>
            <p class="wechat-title">音 乐 窝</p>
            <p class="wechat-typeName">小 程 序</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "contact",
  data() {
    return {
      navData: [
        {
          textName: "客服热线：",
          list: "400-661-8883",
        },
        {
          textName: "合伙人招募：",
          list: "400-661-8883",
        },
        {
          textName: "商务合作：",
          list: "business@musicwow.com",
        },
        {
          textName: "公司地址：",
          list: "广州市海珠区翠华路9号2楼音乐窝教育",
        },
      ],

      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_contact":
            this.bgUrl = item.image;
            break;
        }
      });
    },
  },
  mounted() {},
  created() {
    this.onBulist();
  },
};
</script>
<style lang="sass" scoped>
.contact
  .contact-center
    padding-top: 50px
    img
      width: 100%
    .center-body
      margin: 20px

      h3
        font-size: 24px
      .list-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: 20px auto
      .body-list
        ul
          li
            display: flex
            color: rgba(0,0,0,0.5)
            line-height: 30px
            font-size: 14px

      .body-QR>div
        margin: auto
        width: 140px
        padding: 20px 0
      .body-QR
        display: flex
        flex-wrap: wrap
        font-size: 14px
        margin-top: 20px
        .QR-wechat
          .wechat-img
            width: 96px
            height: 99px
            margin: auto
            img
              width: 100%
              height: 100%
          .dy-img-wrap
            width: 96px
            height: 99px
            overflow: hidden
            margin: auto
            img
              // width: 96px
              // height: 112px
          .wechat-title
            letter-spacing: 4px
          .wechat-name
          .wechat-typeName
            letter-spacing: 4px
</style>

